import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "d-inline ms-2" };
const _hoisted_2 = { class: "modal-title w-100 text-center fw-bold fs-4 mb-4" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "row row-cols-2 row-cols-md-3 mb-4" };
const _hoisted_5 = { class: "col" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
    class: "w-100 d-flex justify-content-center align-items-center",
    style: { "height": "80px" }
};
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_10 = { class: "text-center fw-bold" };
const _hoisted_11 = {
    key: 0,
    class: "text-center small"
};
const _hoisted_12 = {
    key: 0,
    class: "fw-bold border-bottom mb-3 pb-2"
};
const _hoisted_13 = { class: "row row-cols-4 g-4" };
const _hoisted_14 = { class: "col" };
const _hoisted_15 = { class: "bg-light rounded border position-relative" };
const _hoisted_16 = ["src"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "bg-primary d-flex align-items-center justify-content-center flex-column rounded-3 p-5" };
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { class: "bg-danger d-flex align-items-center justify-content-center rounded-3 p-3" };
const _hoisted_23 = { class: "fs-5 fw-bold text-white text-center" };
import { onMounted, ref, watch } from 'vue';
import axios from 'axios';
import { Canvas, loadSVGFromURL, util } from 'fabric';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesignElementManager',
    props: {
        configurationComponentId: String,
        maxElementsAmount: {
            type: Number,
            default: 3
        },
        initialCanvas: Canvas,
        initialImages: (Array)
    },
    emits: ['update', 'usedColors'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const emit = __emit;
        const instanceId = Math.random().toString(36).substring(2, 7);
        const loading = ref(false);
        const error = ref(null);
        const images = ref([]); // Array to hold Fabric image objects (design elements!)
        const availableDesignElements = ref([]);
        const modal = ref();
        onMounted(async () => {
            loadElements();
            if (props.initialCanvas) {
                props.initialCanvas.getObjects('image').forEach((obj) => {
                    if (obj.get('designElement') === true) {
                        images.value.push(obj);
                    }
                });
                props.initialCanvas.getObjects('group', 'path').forEach((obj) => {
                    if (obj.get('designElement') === true) {
                        images.value.push(obj);
                    }
                });
            }
        });
        watch(() => images.value.length, () => {
            emit('update', images.value);
        }, { deep: true });
        function loadElements() {
            axios.post(route('configurator.printConfiguration.designElements.index', props.configurationComponentId))
                .then(function (response) {
                availableDesignElements.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
                showError(error);
            });
        }
        async function selectElement(designElementUuid) {
            if (props.maxElementsAmount != 0 && images.value.length >= props.maxElementsAmount) {
                showError(t('Maximale Anzahl an Design-Elementen erreicht'));
                return;
            }
            loading.value = true;
            axios.post(route('configurator.printConfiguration.designElements.store', {
                configurationDesignElement: designElementUuid,
                configurationComponentId: props.configurationComponentId
            }))
                .then(function (response) {
                createImage(response.data);
                loading.value = false;
            })
                .catch(function (error) {
                console.log(error);
                loading.value = false;
                showError(error);
            });
        }
        function createImage(details) {
            const setImageProperties = (obj) => {
                obj = defineImageStartSize(obj, details.isFullDesign);
                obj.set({
                    left: props.initialCanvas ? (props.initialCanvas.width - obj.width * obj.scaleX) / 2 : 0,
                    top: props.initialCanvas ? (props.initialCanvas.height - obj.height * obj.scaleY) / 2 : 0,
                    borderColor: '#528399',
                    cornerColor: '#528399',
                    cornerSize: 10,
                    transparentCorners: false,
                    borderDashArray: [4, 4],
                    cornerStyle: 'circle'
                });
                obj.set('id', details.id);
                obj.set('url', details.url);
                obj.set('colors', details.colors);
                obj.set('requiredPrintMode', details.requiredPrintMode);
                obj.set('designElement', true);
                if (details.isFullDesign) {
                    obj.set('isFullDesign', true);
                    obj.set('selectable', false);
                }
                images.value.push(obj);
            };
            setTimeout(() => {
                loadSVGFromURL(details.url).then(({ objects }) => {
                    const obj = util.groupSVGElements(objects.filter((o) => o !== null));
                    setImageProperties(obj);
                });
            }, 200);
        }
        function defineImageStartSize(object, isFullDesign) {
            let finished = false;
            if (isFullDesign) {
                let fitScale = Math.min(props.initialCanvas.width / (object.width * object.scaleX), props.initialCanvas.height / (object.height * object.scaleY));
                object.scaleX *= fitScale;
                object.scaleY *= fitScale;
            }
            else {
                while (!finished) {
                    if (props.initialCanvas && ((object.height * object.scaleX) > props.initialCanvas.height || (object.width * object.scaleX) > props.initialCanvas.width)) {
                        object.scaleX *= 0.1;
                        object.scaleY *= 0.1;
                    }
                    else {
                        finished = true;
                    }
                }
            }
            return object;
        }
        function removeImage(imageUuid) {
            try {
                loading.value = true;
                axios.delete(route('configurator.printConfiguration.images.destroy', imageUuid))
                    .then(function (response) {
                    const index = images.value.findIndex(image => image.get('id') === imageUuid);
                    if (index !== -1) {
                        images.value.splice(index, 1);
                    }
                    loading.value = false;
                })
                    .catch(function (error) {
                    console.log(error);
                    loading.value = false;
                });
            }
            catch (error) {
                console.error(error);
                loading.value = false;
            }
        }
        function showError(text) {
            error.value = text;
            setTimeout(() => {
                error.value = null;
            }, 3000);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    class: "btn btn-primary d-inline-flex align-items-center m-2",
                    onClick: _cache[0] || (_cache[0] = ($event) => (modal.value.open($event)))
                }, [
                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-images",
                        viewBox: "0 0 16 16"
                    }, [
                        _createElementVNode("path", { d: "M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" }),
                        _createElementVNode("path", { d: "M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('Vorlagen')), 1)
                ]),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal,
                    id: 'designElements' + _unref(instanceId),
                    tabindex: "-1",
                    "aria-labelledby": "designElementsLabel",
                    "aria-modal": "true",
                    role: "dialog",
                    size: 'lg',
                    closeButton: _unref(t)('weiter')
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('Designs')), 1),
                        _createElementVNode("div", null, [
                            (!loading.value && error.value == null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDesignElements.value, (element) => {
                                            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createElementVNode("button", {
                                                    class: "btn bg-light border border-2 rounded-3 p-0 w-100",
                                                    style: { "overflow": "hidden" },
                                                    onClick: ($event) => (selectElement(element.id))
                                                }, [
                                                    _createElementVNode("div", _hoisted_7, [
                                                        _createElementVNode("img", {
                                                            src: element.image,
                                                            class: "h-75"
                                                        }, null, 8, _hoisted_8)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_9, [
                                                        _createElementVNode("span", _hoisted_10, _toDisplayString(element.name), 1),
                                                        (element.isFullDesign)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('Komplett-Design')), 1))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ], 8, _hoisted_6)
                                            ]));
                                        }), 256))
                                    ]),
                                    (images.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("h6", _hoisted_12, _toDisplayString(_unref(t)('Verwendete Vorlagen')), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_13, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                                            return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("img", {
                                                        src: image.get('url'),
                                                        class: "w-100 p-1"
                                                    }, null, 8, _hoisted_16),
                                                    (image.get('editingBlocked') == null || image.get('editingBlocked') == false)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "btn position-absolute top-0 start-100 translate-middle",
                                                            onClick: ($event) => (removeImage(image.get('id')))
                                                        }, [...(_cache[2] || (_cache[2] = [
                                                                _createElementVNode("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    height: "24",
                                                                    fill: "currentColor",
                                                                    class: "bi bi-x-circle-fill text-danger",
                                                                    viewBox: "0 0 16 16"
                                                                }, [
                                                                    _createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" })
                                                                ], -1)
                                                            ]))], 8, _hoisted_17))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]));
                                        }), 256))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (loading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _cache[3] || (_cache[3] = _createElementVNode("div", {
                                            class: "spinner-grow text-white mb-4",
                                            role: "status"
                                        }, [
                                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                        ], -1)),
                                        _createElementVNode("span", {
                                            class: "fs-5 fw-bold text-white text-center",
                                            innerHTML: _unref(trans)('Bitte warten!<br />Ihre Grafiken/Bilder werden verarbeitet')
                                        }, null, 8, _hoisted_20)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(_Transition, null, {
                                default: _withCtx(() => [
                                    (error.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(error.value), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["id", "closeButton"])
            ], 64));
        };
    }
});
